/* eslint-disable react/prop-types */
import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#3778C2';

const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
		alignItems: 'stretch',
		minHeight: 40,
	},

	cell: {
		fontSize: 8,
		padding: 5,
		borderRightWidth: 1,
		borderRightColor: borderColor,
		justifyContent: 'center',
		display: 'flex',
	},

	id: {
		width: '8%',
		textAlign: 'center',
		borderLeftWidth: 1,
		borderLeftColor: borderColor,
	},

	name: {
		width: '22%',
		textAlign: 'left',
	},

	maintenanceDatetime: {
		width: '28%',
		textAlign: 'center',
	},

	status: {
		width: '16%',
		textAlign: 'center',
	},

	remarks: {
		width: '26%',
		textAlign: 'left',
	},

	endborder: {
		borderBottomColor: borderColor,
		borderBottomWidth: 1,
		width: '100%',
	},
});

const InvoiceTableRow = (props) => {
	const rows = props.data?.map((item, index) => (
		<View key={index} wrap={false}>
			<View style={styles.row}>

				<Text style={[styles.cell, styles.id]}>
					{item?.id ?? ''}
				</Text>

				<Text style={[styles.cell, styles.name]}>
					{item?.name ?? ''}
				</Text>

				<Text style={[styles.cell, styles.maintenanceDatetime]}>
					{item?.maintenanceDatetime ?? ''}
				</Text>

				<Text style={[styles.cell, styles.status]}>
					{item?.status ?? ''}
				</Text>

				<Text style={[styles.cell, styles.remarks]}>
					{item?.remarks ?? ''}
				</Text>

			</View>

			<View style={styles.endborder} />
		</View>
	));

	return <>{rows}</>;
};

export default InvoiceTableRow;